<template>
	<form class="form-horizontal">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col md="6" class="mb-2">

						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kode')}" label="Kode">
							{{ models.kodeFasyankes }}
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Nama')}" label="Nama">
							{{ models.namaFasyankes }}
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jenis Fasyankes')}" label="Jenis Fasyankes">
							{{ getJenisFasyankesById(models.jnsFasyankes) }}
						</b-form-group>
					</b-col>
					<b-col md="6" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kepemilikan')}" label="Kepemilikan">
							{{ getKepemilikanById(models.kepemilikan) }}
						</b-form-group>

						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kelas')}" label="Kelas">
							{{ models.kelas ? models.kelas.namaKelas : "" }}
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Status Usaha')}" label="Status Usaha">
							{{ models.stsUsah ==  0 ? "Tidak Aktif" : "Aktif" }}
						</b-form-group>
					</b-col>
					<h5 class="col-md-12 mb-3 mt-5">Lokasi Fasyankes</h5>
					<b-col md="6" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Alamat')}" label="Alamat">
							{{ models.alamatFasyankes }}
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kota')}" label="Kota">
							{{ models.kota ? models.kota.namaKelas :  "" }}
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kecamatan')}" label="Kecamatan">
							{{ models.kecamatan ? models.kecamatan.namaKecamatan :  "" }}
						</b-form-group>
					</b-col>
					<b-col md="6" class="mb-2">
						
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kelurahan')}" label="Kelurahan">
							{{ models.kelurahan ? models.kelurahan.namaKelurahan :  "" }}
						</b-form-group>
						<b-form-group label="Longitude">
							{{ models.longitude }}
						</b-form-group>
						<b-form-group label="Latitude">
							{{ models.latitude }}
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';
	import { getJenisFasyankesById, getKepemilikanById } from '@/utils/helpers';

	export default {
		name: 'ViewFasyankes',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
					kelas: {},
				},
			}
		},
		created() {
			const _ = this
			_.getById();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`Fasyankes/${_.$route.params.id}`);
						_.models = request.data.data;
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
			},
            getJenisFasyankesById(id){
                return getJenisFasyankesById(id);
            },
            getKepemilikanById(id){
                return getKepemilikanById(id);
            }
		}
	}
</script>